<template>
  <ul class="grid">
    <li v-for="post in posts" :key="post.id">
      <ChapterGridVideoItem
        :id="post.id"
        :key="post.id"
        class="card"
        :path="post.path"
        :text="post.title"
        :locked-content="post.lockedContent"
        :content-type="post.contentType"
        :thumbnail-url="post.thumbnailUrl"
        :video-url="post.videoUrl"
      />
    </li>
  </ul>
</template>
<script lang="ts" setup>
interface Props {
  category: CategorySchema;
}

const props = defineProps({
  category: null
});

const { posts } = useCategoryBlockPosts(props.category);
</script>
<style lang="scss" scoped>
.grid {
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
  @include above('m') {
    grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
  }

  width: 100%;
  gap: var(--gap_l);

  li .card {
    height: 100%;
  }
}
</style>
